// pages/Error404.jsx
import React from 'react';
import Topbar from '../components/Topbar';


function Error404() {
  return (
    <div className="wrapper">
      <Topbar />

      <section className="container py-3">
        <h2>404 Error</h2>
        <p>This page not found.</p>
      </section>
    </div>
  );
}

export default Error404;
